import { Reveal } from "@/components/site/Reveal";
import { Icon } from "@/components/site/icons";
import { useLanguage } from "@/context/LanguageContext";
import { ArrowUpRight } from "lucide-react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const Services = () => {
  const { t } = useLanguage();
  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <Reveal>
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[#B87333]" />
              <span className="overline text-[#B87333]">{t.services.overline}</span>
            </div>
            <h2 className="font-display text-[#0B1F33] font-extrabold tracking-tighter leading-[1.02] text-4xl lg:text-5xl">
              {t.services.title}
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.services.items.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.08}>
              <button
                data-testid={`service-card-${i}`}
                onClick={() => scrollTo("contact")}
                className="group text-left w-full h-full bg-white border border-[#E5E7EB] p-8 hover:border-[#B87333] hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(11,31,51,0.35)] transition-all duration-300 flex flex-col"
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 grid place-items-center border border-[#0B1F33]/10 text-[#0B1F33] group-hover:bg-[#0B1F33] group-hover:text-white transition-colors duration-300">
                    <Icon name={s.icon} size={22} strokeWidth={1.6} />
                  </div>
                  <span className="font-display text-xs font-bold text-[#E5E7EB] group-hover:text-[#B87333] transition-colors">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="mt-6 font-display text-xl font-bold text-[#0B1F33] tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-[#6B7280] text-sm leading-relaxed flex-1">{s.text}</p>
                <span className="mt-6 inline-flex items-center gap-1.5 text-[13px] font-semibold text-[#0B1F33] group-hover:text-[#B87333] transition-colors">
                  {t.services.cta}
                  <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
